(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brakemade-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('brakemade-delivery-clock')) {
    customElements.define('brakemade-delivery-clock', class extends HTMLElement {
      connectedCallback() {
        if (this.clockInterval) return;
        const root = this;
        const set = (selector, value) => {
          const element = root.querySelector(selector);
          if (element) element.textContent = value;
        };
    const cutoffHour = 13;
    const zone = 'America/Chicago';
    const dateFormatter = new Intl.DateTimeFormat('en-US', {timeZone:'UTC',month:'short',day:'2-digit'});
    const customerDateFormatter = new Intl.DateTimeFormat('en-US', {month:'short',day:'2-digit'});
    const partsFormatter = new Intl.DateTimeFormat('en-US', {timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
    const chicagoDate = (instant) => {
      const parts = {};
      partsFormatter.formatToParts(instant).forEach((part) => {
        if (part.type !== 'literal') parts[part.type] = Number(part.value);
      });
      return new Date(Date.UTC(parts.year,parts.month-1,parts.day,parts.hour,parts.minute,parts.second));
    };
    const dateKey = (date) => [date.getUTCFullYear(),String(date.getUTCMonth()+1).padStart(2,'0'),String(date.getUTCDate()).padStart(2,'0')].join('-');
    const observedFixedHoliday = (year,month,day) => {
      const holiday = new Date(Date.UTC(year,month,day));
      if (holiday.getUTCDay() === 6) holiday.setUTCDate(holiday.getUTCDate()-1);
      if (holiday.getUTCDay() === 0) holiday.setUTCDate(holiday.getUTCDate()+1);
      return holiday;
    };
    const fixedHolidayDates = (year,month,day) => {
      const actual = new Date(Date.UTC(year,month,day));
      const observed = observedFixedHoliday(year,month,day);
      return dateKey(actual) === dateKey(observed) ? [actual] : [actual,observed];
    };
    const nthWeekday = (year,month,weekday,nth) => {
      const date = new Date(Date.UTC(year,month,1));
      date.setUTCDate(1+((7+weekday-date.getUTCDay())%7)+((nth-1)*7));
      return date;
    };
    const lastWeekday = (year,month,weekday) => {
      const date = new Date(Date.UTC(year,month+1,0));
      date.setUTCDate(date.getUTCDate()-((7+date.getUTCDay()-weekday)%7));
      return date;
    };
    const postalHolidayKeys = (year) => [
      ...fixedHolidayDates(year,0,1),
      nthWeekday(year,0,1,3),
      nthWeekday(year,1,1,3),
      lastWeekday(year,4,1),
      ...fixedHolidayDates(year,5,19),
      ...fixedHolidayDates(year,6,4),
      nthWeekday(year,8,1,1),
      nthWeekday(year,9,1,2),
      ...fixedHolidayDates(year,10,11),
      nthWeekday(year,10,4,4),
      ...fixedHolidayDates(year,11,25)
    ].map(dateKey);
    const holidayCache = new Map();
    const isPostalHoliday = (date) => {
      const year = date.getUTCFullYear();
      if (!holidayCache.has(year)) {
        holidayCache.set(year,new Set([
          ...postalHolidayKeys(year-1),
          ...postalHolidayKeys(year),
          ...postalHolidayKeys(year+1)
        ]));
      }
      return holidayCache.get(year).has(dateKey(date));
    };
    const isShipDay = (date) => date.getUTCDay() !== 0 && !isPostalHoliday(date);
    const isDeliveryDay = (date) => date.getUTCDay() !== 0 && !isPostalHoliday(date);
    const nextShipDay = (date) => {
      const result = new Date(date);
      do { result.setUTCDate(result.getUTCDate()+1); } while (!isShipDay(result));
      return result;
    };
    const addDeliveryDays = (date, amount) => {
      const result = new Date(date);
      let remaining = amount;
      while (remaining > 0) {
        result.setUTCDate(result.getUTCDate()+1);
        if (isDeliveryDay(result)) remaining -= 1;
      }
      return result;
    };
    const formatDate = (date) => dateFormatter.format(date);
    const formatRange = (start,end) => formatDate(start) === formatDate(end) ? formatDate(start) : formatDate(start)+'–'+formatDate(end);

    const render = () => {
      const customerNow = new Date();
      const now = chicagoDate(customerNow);
      let shipStart = new Date(now);
      if (!isShipDay(shipStart) || shipStart.getUTCHours() >= cutoffHour) shipStart = nextShipDay(shipStart);
      const cutoff = new Date(shipStart);
      cutoff.setUTCHours(cutoffHour,0,0,0);
      const remainingMinutes = Math.floor(Math.max(0,cutoff.getTime()-now.getTime())/60000);
      const deliveryStart = addDeliveryDays(shipStart,2);
      const deliveryEnd = addDeliveryDays(shipStart,5);
      set('[data-delivery-countdown]', String(Math.floor(remainingMinutes/60)).padStart(2,'0')+'h '+String(remainingMinutes%60).padStart(2,'0')+'m');
      set('[data-processing-date]', formatDate(shipStart));
      set('[data-order-date]', customerDateFormatter.format(customerNow));
      set('[data-ship-date]', formatDate(shipStart));
      set('[data-delivery-date]', formatRange(deliveryStart,deliveryEnd));
    };

        render();
        this.clockInterval = window.setInterval(render, 30000);
      }
      disconnectedCallback() {
        window.clearInterval(this.clockInterval);
        this.clockInterval = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
